// extracted by mini-css-extract-plugin
export var chip = "_4u-0";
export var filterDropdown = "_4u-5";
export var filterItem = "_4u-6";
export var icon = "_4u-1";
export var removeButton = "_4u-3";
export var removeIcon = "_4u-4";
export var separator = "_4u-2";